import React from 'react';
import strings from "../../../localization";
import { getError, hasError } from "../../../functions/Validation";
import { Button, TextField } from "@material-ui/core";

const TransporterForm = ({
  onSubmit,
  onCancel,
  onChange,
  errors,
  data,
  isDisabled
}) => {
  return (

    <form id='user-form'>
      {/* <TextField
        label={strings.transporter.form.code + "*"}
        error={hasError(errors, 'code')}
        helperText={getError(errors, 'code')}
        fullWidth
        autoFocus
        name='code'
        onChange={onChange}
        margin="normal"
        defaultValue={data.code}
        value={data.code}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      /> */}
      <TextField
        label={strings.transporter.form.name + "*"}
        error={hasError(errors, 'name')}
        helperText={getError(errors, 'name')}
        fullWidth
        name='name'
        onChange={onChange}
        margin="normal"
        defaultValue={data.name}
        value={data.name}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      />
      <TextField
        label={strings.transporter.form.shortenedName + "*"}
        error={hasError(errors, 'shortenedName')}
        helperText={getError(errors, 'shortenedName')}
        fullWidth
        name='shortenedName'
        onChange={onChange}
        margin="normal"
        defaultValue={data.shortenedName}
        value={data.shortenedName}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      />
      <TextField
        multiline={true}
        rowsMax={5}
        label={strings.transporter.form.address}
        error={hasError(errors, 'address')}
        helperText={getError(errors, 'address')}
        fullWidth
        name='address'
        onChange={onChange}
        margin="normal"
        defaultValue={data.address}
        value={data.address}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      />

      {
        !isDisabled &&
        <div className='submit-container'>
          <Button variant="contained" color="primary" onClick={onSubmit}>
            {strings.transporter.form.ok}
          </Button>
          <Button variant="contained" color="secondary" onClick={onCancel}>
            {strings.transporter.form.cancel}
          </Button>
        </div>
      }
    </form>
  )
};

export default TransporterForm;